import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.t('编辑认证信息'),
      "width": 700
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    staticClass: "tooptip-form-box",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formDataRule,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "",
      "wrapper-col": {
        span: 18,
        offset: 6
      }
    }
  }, [_c('a-alert', {
    attrs: {
      "message": _vm.t('以下内容仅用于实名认证，请填写您的真实信息，否则会认证不通过'),
      "type": "info",
      "show-icon": ""
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8BA4\u8BC1\u7C7B\u578B"),
      "prop": "certification_type",
      "label": _vm.t('认证类型')
    }
  }, [_c('div', {
    staticClass: "flex-box"
  }, [_c('div', {
    staticClass: "flex-content"
  }, [_c('my-select', {
    attrs: {
      "disabled": true,
      "size": "large"
    },
    model: {
      value: _vm.formData.certification_type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "certification_type", $$v);
      },
      expression: "formData.certification_type"
    }
  }, _vm._l(_vm.certificationTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _vm.formData.certification_type === _vm.$enum.mine.CertificationTypeEnum.ORGANIZATION ? _c('a-radio-group', {
    attrs: {
      "prop": "is_agent"
    },
    model: {
      value: _vm.formData.is_agent,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "is_agent", $$v);
      },
      expression: "formData.is_agent"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0,
      "fbu-analyse-name": $t("\u65E0\u4EE3\u7406\u4EBA")
    }
  }, [_vm._v(_vm._s(_vm.t('无代理人')))]), _c('a-radio', {
    attrs: {
      "value": 1,
      "fbu-analyse-name": $t("\u6709\u4EE3\u7406\u4EBA")
    }
  }, [_vm._v(_vm._s(_vm.t('有代理人')))])], 1) : _vm._e()], 1)])]), _vm.formData.certification_type === _vm.$enum.mine.CertificationTypeEnum.ORGANIZATION ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u6CD5\u4EBA\u59D3\u540D"),
      "prop": "name",
      "label": _vm.t('法人姓名')
    }
  }, [_c('a-input', {
    staticClass: "flex-content",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入法人姓名')
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.name"
    }
  })], 1) : _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u59D3\u540D"),
      "prop": "name",
      "label": _vm.t('姓名')
    }
  }, [_c('a-input', {
    staticClass: "flex-content",
    attrs: {
      "size": "large",
      "placeholder": _vm.t('请输入姓名')
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u624B\u673A\u53F7"),
      "prop": "phone_number"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.t('手机号')) + " "), _c('a-tooltip', {
    attrs: {
      "placement": "top",
      "title": _vm.t('合同盖章时需要用该手机接收验证码')
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "question-circle"
    }
  })], 1)], 1), _c('a-input', {
    staticClass: "flex-content",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('合同盖章时需要用该手机接收验证码')
    },
    model: {
      value: _vm.formData.phone_number,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "phone_number", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.phone_number"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8BC1\u4EF6\u7C7B\u578B"),
      "prop": "id_card_type",
      "label": _vm.t('证件类型')
    }
  }, [_c('my-select', {
    staticClass: "flex-content",
    attrs: {
      "size": "large",
      "disabled": ""
    },
    model: {
      value: _vm.formData.id_card_type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "id_card_type", $$v);
      },
      expression: "formData.id_card_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v(_vm._s(_vm.tc('身份证')))])], 1)], 1), _vm.formData.certification_type === _vm.$enum.mine.CertificationTypeEnum.ORGANIZATION ? _c('a-form-model-item', {
    attrs: {
      "prop": "id_card_number",
      "label": _vm.t('法人证件号')
    }
  }, [_c('a-input', {
    staticClass: "flex-content",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入法定代表人身份证号码')
    },
    model: {
      value: _vm.formData.id_card_number,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "id_card_number", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.id_card_number"
    }
  })], 1) : _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8BC1\u4EF6\u53F7\u7801"),
      "prop": "id_card_number",
      "label": _vm.t('证件号码')
    }
  }, [_c('a-input', {
    staticClass: "flex-content",
    attrs: {
      "size": "large",
      "placeholder": _vm.t('请输入身份证号码')
    },
    model: {
      value: _vm.formData.id_card_number,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "id_card_number", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.id_card_number"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4F01\u4E1A\u540D\u79F0"),
      "prop": "company_name",
      "label": _vm.t('企业名称')
    }
  }, [_c('a-input', {
    staticClass: "flex-content",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "disabled": "",
      "placeholder": _vm.t('请输入企业名称')
    },
    model: {
      value: _vm.formData.company_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "company_name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.company_name"
    }
  })], 1), _vm.formData.certification_type === _vm.$enum.mine.CertificationTypeEnum.ORGANIZATION ? _c('a-form-model-item', {
    attrs: {
      "prop": "credit_code",
      "label": _vm.t('统一社会信用代码')
    }
  }, [_c('a-input', {
    staticClass: "flex-content",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "disabled": "",
      "size": "large",
      "placeholder": _vm.t('营业执照上的统一社会信用代码')
    },
    model: {
      value: _vm.formData.credit_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "credit_code", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.credit_code"
    }
  })], 1) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4F01\u4E1A\u8425\u4E1A\u6267\u7167"),
      "label": _vm.t('企业营业执照')
    }
  }, [_c('div', {
    staticClass: "flex-content"
  }, [_c('my-image', {
    attrs: {
      "url": _vm.data.sign_body_info ? _vm.data.sign_body_info.business_license_url : ''
    }
  })], 1)]), _vm.formData.is_agent === _vm.$enum.mine.IsAgentEnum.YES ? _c('div', [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4EE3\u7406\u4EBA\u59D3\u540D"),
      "prop": "agent_name",
      "label": _vm.t('代理人姓名')
    }
  }, [_c('a-input', {
    staticClass: "flex-content",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入代理人姓名')
    },
    model: {
      value: _vm.formData.agent_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "agent_name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.agent_name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4EE3\u7406\u4EBA\u624B\u673A\u53F7"),
      "prop": "agent_phone_number",
      "label": _vm.t('代理人手机号')
    }
  }, [_c('a-input', {
    staticClass: "flex-content",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入代理人手机号')
    },
    model: {
      value: _vm.formData.agent_phone_number,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "agent_phone_number", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.agent_phone_number"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4EE3\u7406\u4EBA\u8EAB\u4EFD\u8BC1\u53F7\u7801"),
      "prop": "agent_id_card_number",
      "label": _vm.t('代理人身份证号码')
    }
  }, [_c('a-input', {
    staticClass: "flex-content",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入代理人身份证号码')
    },
    model: {
      value: _vm.formData.agent_id_card_number,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "agent_id_card_number", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.agent_id_card_number"
    }
  })], 1)], 1) : _vm._e()], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "welcome_certification_cancel",
      "id": "welcome_certification_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "welcome_certification_submit",
      "id": "welcome_certification_submit",
      "fbu-analyse-name": $t("\u63D0\u4EA4")
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.t('提交')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };